import { render, staticRenderFns } from "./NewNuestraRed.vue?vue&type=template&id=00634c69&scoped=true"
import script from "./NewNuestraRed.vue?vue&type=script&lang=ts"
export * from "./NewNuestraRed.vue?vue&type=script&lang=ts"
import style0 from "./NewNuestraRed.vue?vue&type=style&index=0&id=00634c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00634c69",
  null
  
)

export default component.exports